var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8AB03",
    fillRule: "evenodd",
    d: "M12.415 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-1 9a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0v5Zm1 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;